import { HttpClient } from 'api/HttpClient';
import { Lender } from 'enums/ApplicationsVariables';

import { OfferResponseDto } from './AutomatedOffersApi';

export interface OfferDto {
  loanAmount: number;
  grossLoanAmount: number;
  term: number;
  rate: number;
  apr: number;
  monthlyPayment: number;
  lender: Lender;
  offerUrl: string;
  oneTimeFeePercentage: number;
  isBestPayment?: boolean;
  isLowestPayment?: boolean;
  isLowestRate?: boolean;
}

export interface OffersResponseDto {
  loanAmount: number;
  loanOffers: OfferDto[];
  isApplicationRejected: boolean;
}

export interface DeclineOfferDto {
  applicationId: string;
  isWithdrawn: boolean;
}

export interface UpdateOfferRequestDto {
  applicationId: string;
  loanAmount: number;
  loanTerm: string;
}

export interface OneTermOfferResponseDto {
  loanAmount: number;
  grossLoanAmount: number;
  term: number;
  rate: number;
  apr: number;
  monthlyPayment: number;
  lender: Lender;
  offerUrl: string;
  oneTimeFeePercentage: number;
  isBestPayment?: boolean;
  isLowestPayment?: boolean;
  isLowestRate?: boolean;
}

export interface AcceptMultiTermOfferRequestDto {
  applicationId: string;
  term: number;
}

export interface AcceptMultiTermOfferResponseDto {
  isApplicationRejected: boolean;
}

export default class OffersApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/offers' || '');
  }

  public async getOneTermOffers(applicationId: string): Promise<OneTermOfferResponseDto[]> {
    return this.instance.get(`/one-term?applicationId=${applicationId}`).then((response) => response.data);
  }

  public async getMultipleTermOffers(applicationId: string): Promise<OffersResponseDto> {
    return this.instance.get(`/multi-term?applicationId=${applicationId}`).then((response) => response.data);
  }

  public async getOffer(applicationId: string, loanAmount?: number, loanTerm?: string): Promise<OfferResponseDto> {
    return this.instance
      .get(`/offer?applicationId=${applicationId}&loanAmount=${loanAmount}&loanTerm=${loanTerm}`)
      .then((response) => response.data);
  }

  public async acceptOneTermOffer(applicationId: string): Promise<void> {
    return this.instance.post('/one-term', { applicationId: applicationId }).then((response) => response.data);
  }

  public async acceptMultiTermOffer(
    acceptMultiTermOfferRequestDto: AcceptMultiTermOfferRequestDto,
  ): Promise<AcceptMultiTermOfferResponseDto> {
    return this.instance.post('/multi-term', acceptMultiTermOfferRequestDto).then((response) => response.data);
  }

  public async declineOffer(declineOfferDto: DeclineOfferDto): Promise<void> {
    return this.instance.post('/decline', declineOfferDto).then((response) => response.data);
  }

  public async updateOffer(updateOfferDto: UpdateOfferRequestDto): Promise<void> {
    return this.instance.put('', updateOfferDto).then((response) => response.data);
  }
}

export const offersApi = new OffersApi();
